export class pageModel{
    pageIndex:number;
    pageSize:number;
    totalCount:number;
  }